// ── usePolyAccount — Auto-connect lifecycle hook ────────────────
// Mirrors useKalshiAccount pattern. On mount, checks localStorage
// for saved config and connects if found. Disconnects on unmount.
//
// Role gate: trader-role users are not allowed to use personal-key
// Polymarket trading inside this app. The auto-connect is skipped
// for them; the central mount in AuthedShell takes care of clearing
// any pre-existing localStorage config so a recently-demoted trader
// doesn't have stale credentials sitting around.

import { useEffect } from 'react';
import { usePolyAccountStore, autoConnectPoly } from '../stores/polyAccountStore';
import { useAuthStore } from '../stores/authStore';

export function usePolyAccount(): void {
  useEffect(() => {
    const role = useAuthStore.getState().user?.role;
    if (role === 'trader') {
      // Defense in depth: skip auto-connect entirely. If somehow a
      // PolyAccountCard renders under this role (it shouldn't — Settings
      // hides it) the store stays in its disconnected baseline.
      return;
    }
    autoConnectPoly();

    return () => {
      usePolyAccountStore.getState().disconnect();
    };
  }, []);
}
